document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.ratingSnippet === 'function') {
    window.ratingSnippet('ruk_rating_snippet', {
      store: 'uk-oak-doors',
      mode: 'default',
      color: '#FFB801',
      linebreak: false,
      text: '',
      singularText: '',
      lang: 'en',
      usePolaris: false,
      showEmptyStars: true,
      showNumericalAverageRating: false,
    });
  }

  const ratingSnippetElement = document.querySelector('.custom-product-rating-snippet');
  if (!ratingSnippetElement) return;

  ratingSnippetElement.addEventListener('click', function () {
    const reviewSummary = document.querySelector('#review-summary');
    if (!reviewSummary) return;

    const accordion = reviewSummary.closest('.pad-details');
    if (!accordion || typeof Alpine === 'undefined') return;

    Alpine.evaluate(accordion, 'open = true');

    const yOffset = -150;
    const y = accordion.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth',
    });
  });
});

